import React from "react";
import { experience } from "@/lib/data";
import { SectionHeader } from "@/components/About";

export default function Experience() {
    return (
        <section
            id="experience"
            data-testid="experience-section"
            className="relative py-24 md:py-32 border-t border-term-green/15"
        >
            <SectionHeader
                index="03"
                label="work log"
                command="git log --oneline experience/"
            />

            <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14">
                <ol
                    data-testid="experience-timeline"
                    className="relative border-l border-term-green/25 ml-2"
                >
                    {experience.map((exp, i) => (
                        <ExperienceItem key={exp.company} exp={exp} index={i} />
                    ))}
                </ol>
            </div>
        </section>
    );
}

function ExperienceItem({ exp, index }) {
    return (
        <li
            data-testid={`experience-item-${index}`}
            className="relative pl-8 md:pl-12 pb-14 last:pb-0"
        >
            {/* Node */}
            <span className="absolute -left-[10px] top-1.5 font-mono text-term-green text-base leading-none select-none">
                [+]
            </span>

            <div className="grid lg:grid-cols-12 gap-6">
                {/* Left: meta */}
                <div className="lg:col-span-4 space-y-1.5 font-mono text-xs">
                    <div className="text-[10.5px] uppercase tracking-[0.24em] text-term-green">
                        // commit_{String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="text-ink-secondary">{exp.period}</div>
                    <div className="text-ink-tertiary">{exp.duration}</div>
                </div>

                {/* Right: content */}
                <div className="lg:col-span-8 space-y-4">
                    <div>
                        <h4 className="font-mono text-xl md:text-2xl font-bold text-ink-primary leading-tight">
                            {exp.role}{" "}
                            <span className="text-term-green">@ {exp.company}</span>
                        </h4>
                        {exp.context && (
                            <p className="font-mono text-xs text-ink-tertiary mt-2">
                                {exp.context}
                            </p>
                        )}
                    </div>

                    <ul className="space-y-2.5">
                        {exp.bullets.map((b, i) => (
                            <li
                                key={i}
                                className="flex items-baseline gap-3 font-display text-sm md:text-[15px] text-ink-secondary leading-relaxed"
                            >
                                <span className="text-term-green font-mono mt-0.5">
                                    ▸
                                </span>
                                <span>{b}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </li>
    );
}
